(function () {
  'use strict';

  /* ========================================================================
     Moonou Footer
     1) Wordmark auto-sizing (reads data-max-fs / data-max-fs-m)
     2) Force footer accordions open (sets data-opened so FooterDetails
        keeps them open on mobile)
     ======================================================================== */

  /* ---- Wordmark Auto-Sizing ---- */

  function fitWordmark(container) {
    var textEl = container.querySelector('.moonou-wordmark__text');
    if (!textEl) return;

    var containerWidth = container.offsetWidth;
    if (containerWidth <= 0) return;

    var isMobile = window.innerWidth < 768;
    var maxFs = parseFloat(container.getAttribute(isMobile ? 'data-max-fs-m' : 'data-max-fs')) || 500;

    // Measure at max font-size
    textEl.style.fontSize = maxFs + 'px';
    var textWidth = textEl.scrollWidth;
    if (textWidth <= 0) return;

    // Scale to fill container width, capped at max
    var optimalFs = Math.min(maxFs, (containerWidth / textWidth) * maxFs);
    textEl.style.fontSize = Math.floor(optimalFs) + 'px';
  }

  /* ---- Footer Accordions ---- */

  function initFooterAccordions() {
    var details = document.querySelectorAll('.footer-group details[is="footer-details"]');
    details.forEach(function (el) {
      // data-opened tells FooterDetails.load() to keep them open on mobile
      el.setAttribute('data-opened', '');
      // Force open immediately
      if (!el.hasAttribute('open')) {
        el.setAttribute('open', '');
      }
    });
  }

  /* ---- Initialization ---- */

  function init() {
    initFooterAccordions();

    var el = document.querySelector('.moonou-wordmark');
    if (el) {
      fitWordmark(el);

      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(function () {
          fitWordmark(el);
        }).observe(el);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
